<script lang="ts">
  import { getModalStore, type ModalSettings } from '@skeletonlabs/skeleton';
  import { ButtonSmall } from '$lib/components/button';
  import { TextCopy } from '$lib/components/text';
  import type { CompanyDto } from '$lib/features/bff/sdk';
  import { CompanyModalExport } from '$lib/features/company';
  import { formatCompanyId, formatNumber } from '$lib/features/format';

  /** Required */
  export let company: CompanyDto;

  const modalStore = getModalStore();

  let createListJobModal: ModalSettings;

  $: createListJobModal = {
    type: 'component',
    title: 'Exportar Lista',
    component: { ref: CompanyModalExport },
    meta: { company },
  };
</script>

<div class="mb-6 flex flex-col gap-x-4 gap-y-6 sm:flex-row">
  <!-- Title Container -->
  <div class="flex-1 overflow-hidden">
    <!-- Title -->
    <p class="truncate text-nowrap text-2xl font-medium">
      <TextCopy value={company.name} />
    </p>

    <!-- Company ID -->
    <p class="text-surface-600-300-token">
      <TextCopy value={formatCompanyId(company.id)} onCopy={(v) => v.replace(/\D+/g, '')} />
    </p>
  </div>

  <!-- Actions Container -->
  <div class="flex flex-wrap gap-4">
    <!-- Download All -->
    <ButtonSmall
      icon="play"
      label={`Exportar (${formatNumber(company.offices.length)})`}
      variant="variant-soft-surface"
      tooltip={company.offices.length === 1
        ? `Exportar uma lista com os dados do estabelecimento desta empresa.`
        : `Exportar uma lista com os dados dos ${formatNumber(company.offices.length)} estabelecimentos desta empresa.`}
      tooltipFont="text-sm"
      tooltipWidth="max-w-72"
      requireLogin
      onClick={() => modalStore.trigger(createListJobModal)}
    />
  </div>
</div>
